<template>
  <div class="home-content buy-page-box">
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <div class="home-header">
      <!-- title -->
      <headers :params="hraderP"></headers>
      <!-- 收藏 支付 切换 -->
      <div class="mine">
        <div @click="nimeColor = true" :class="{'color1':nimeColor,'color2':!nimeColor}" style="margin: 5px 0 5px 8%;border-radius: 6px 0 0 6px;">我购买的方案</div>
        <div  @click="nimeColor = false" :class="{'color1':!nimeColor,'color2':nimeColor}" style="margin: 5px 8% 5px 0;border-radius: 0 6px 6px 0;">我收藏的方案</div>
      </div>
      <!-- tab 切换 -->
      <van-tabs v-show="nimeColor" v-model="active" color="#2F7BFF" class="tabs" line-width="50%">
        <van-tab title="待支付"></van-tab>
        <van-tab title="已支付"></van-tab>
      </van-tabs>
    </div>
    <div v-if="isNativeApp&&nimeColor" style="height: 1.3rem;"></div>
    <div class="" v-if="active == 0&&nimeColor">
      <unPaymentList></unPaymentList>
    </div>
    <div v-if="active == 1&&nimeColor">
      <paymentedList></paymentedList>
    </div>
    <div v-if="!nimeColor">
      <collectList></collectList>
    </div>
    <!-- <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link> -->
  </div>
</template>

<script>
import headers from '@/components/headers'
import wxAuth from '@/components/wxAuth'
import unPaymentList from '@/components/unPaymentList'
import paymentedList from '@/components/paymentedList'
import { connectWebViewJavascriptBridge } from '@/utils/OverallJsMobile'
import collectList from '@/components/collectionList'
export default {
  name: 'home',
  components: { headers, wxAuth, unPaymentList, paymentedList, collectList },
  data () {
    return {
      //我的收藏  支付
      nimeColor:true,
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '我的方案',
        lefticon: true
      },
      active: 0,
      isNativeApp: false
    }
  },
  created () {
    this.isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
  },
  mounted () {

    if (this.$route.query.tab === 'shou') {
      this.nimeColor = false
    }
    if (this.$route.query.type === 'paid') {
      this.active = 1
    }
    if (($HMD$.rNavigator.toLowerCase() === 'ios' ||  $HMD$.rNavigator.toLowerCase() === 'android') && this.$route.query.source !== 'solution') {
      this.iosReturnPage()
    }
  },
  methods: {
    // 原生APP 调用分享
    iosReturnPage () {
      let _this = this
      connectWebViewJavascriptBridge(function (bridge) {
        if ($HMD$.rNavigator.toLowerCase() === 'android') {
          bridge.callHandler('registerHDBridgeHandler', {
            'name': 'needask',
            'value': 'true'
          }, function (response) {})
        }
        bridge.registerHandler('callHDBridgeHandler', function (message, responseCallback) {
          let jsonMessage = JSON.parse(message)
          if (typeof (jsonMessage.name) !== 'undefined' && jsonMessage.name === 'payCanBack') {
            let data = {
              'name': 'toHome',
            }
            // 调用原生方法
            bridge.callHandler('registerHDBridgeHandler', data, function (response) {})
          }
        })
      })
    },
  }
}
</script>

<style lang="scss">
.buy-page-box {
  .home-header{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
  }
}

.tabs .van-tab--active{
    color: #2F7BFF;
}
.to-index{
  width: 122px;
  position: fixed;
  right: 10px;
  bottom: 10px;
}
.mine{
  height:44px;
  width: 100%;
  background: #ffffff;
  display: flex;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  div{
    width: 42%;
    height: 70%;
    border: 1px solid #2F7BFF;
    line-height: 2;
  }
  .color1{
    color: #ffffff;
    background: #2F7BFF;
  }
  .color2{
    color: #2F7BFF;
    background: #ffffff;
  }
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width:0;
}
</style>



// WEBPACK FOOTER //
// src/view/solutionBuy/list.vue